module.exports = __webpack_public_path__ + "static/img/contest_trophy.0b1507f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contests/contest_trophy.png
// module id = xx9S
// module chunks = 12